module.exports = __webpack_public_path__ + "img/PXL_20230523_141941372.818de4f6.jpg";